import { useState } from "react";
import MainContainer from "../../components/partials/maincontainer";
import { IconButton } from "../../components/partials/btn";
// import { Icon } from "@iconify/react";
import { useSystemInformAreaStore } from "../../data/stores/loggerStore";
import SystemInformAreaTable from "../../components/tables/SystemInformArea";
import { useNavigate } from "react-router-dom";
import { SearchInput } from "../../components/partials/inputs";

const Requests = () => {
  const [activeTab, setActiveTab] = useState("view-all"),
    [search, setSearch] = useState(""),
    { allData }: any = useSystemInformAreaStore(),
    navigate = useNavigate();
  return (
    <div>
      <MainContainer>
        <div className="bg-transparent main-border main-shadow rounded-lg">
          <div
            style={{
              borderBottom: "1px solid #D7E2EC",
            }}
            className="h-24 w-full px-5 flex justify-between items-center"
          >
            <div>
              <div className="flex gap-2 items-center">
                <h4 className="text-lg font-medium text-sec">
                  System Inform Area
                </h4>
                <button className="h-6 px-5 bg-[#E6F3FE] rounded-lg text-xs font-medium text-[#2070B8]">
                  {allData?.totalDocs}{" "}
                  {allData?.totalDocs > 1 ? "Areas" : "Area"}
                </button>
              </div>
              <p className="text-sm text-es-gray-100 mt-1 font-normal">
                Keep track of area updates
              </p>
            </div>
            <div className="flex gap-5 items-center">
              <IconButton
                onClick={() => navigate("manage-data")}
                icon="material-symbols:add"
                color="white"
                text="New Area"
                bg="#2070B8"
              />
            </div>
          </div>

          <div
            style={{
              borderBottom: "1px solid #D7E2EC",
            }}
            className="h-20 w-full px-5 flex justify-between items-center"
          >
            <div className="inline-flex h-11 rounded-lg main-border overflow-hidden">
              <button
                className={`px-6  text-sm font-medium ${
                  activeTab === "view-all"
                    ? "bg-[#F9FAFB] text-gray-800"
                    : "bg-transparent text-gray-600 hover:text-gray-800"
                }`}
                onClick={() => setActiveTab("view-all")}
              >
                View all
              </button>
              <div className="h-full w-px bg-[#d0d5dd]" />
              <button
                className={`px-6 text-sm font-medium ${
                  activeTab === "newly-uploaded"
                    ? "bg-[#F9FAFB] text-gray-800"
                    : "bg-transparent text-gray-600 hover:text-gray-800"
                }`}
                onClick={() => setActiveTab("newly-uploaded")}
              >
                Newly Uploaded
              </button>
            </div>
            <div className="flex gap-4 items-center">
              <SearchInput
                value={search}
                onChange={(e) => {
                  setSearch(e);
                }}
              />
              {/* <IconButton icon="famicons:filter" text="Filter" /> */}
            </div>
          </div>
          <SystemInformAreaTable usecase={activeTab} search={search} />
        </div>
      </MainContainer>
    </div>
  );
};

export default Requests;
